import { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

const themeTypes = {
    success: {
        contentBgClassName: 'success-warning',
        iconBgClassName: 'success-warning-icon',
    },
    warning: {
        contentBgClassName: 'info-warning',
        iconBgClassName: 'info-warning-icon',
    },
    error: {
        contentBgClassName: 'error-warning',
        iconBgClassName: 'error-warning-icon',
    },
}

interface InfoMessageProps {
    type: keyof typeof themeTypes
    label: string
    icon?: IconProp
    dataCy?: string
}

const InfoMessage: FC<InfoMessageProps> = ({ type, label, icon, dataCy }) => {
    return (
        <div className={`w-100 flex justify-start items-center ${themeTypes[type].contentBgClassName} `} data-cy={dataCy}>
            {icon && <FontAwesomeIcon icon={icon as any} className={themeTypes[type].iconBgClassName} />}
            <span className="text-base pt-[14px] pb-[10px] pr-[10px] max-tablet:text-sm max-tablet:pt-[13px] max-tablet:pb-[8px] max-tablet:pr-[8px]">
                {label}
            </span>
        </div>
    )
}

export default InfoMessage
